<div class="flightScaleDs__cont">
  <div class="flightScaleDs__stops flightScaleDs__stops--{{viewStops}} flightScaleDs__stops--{{size}}">
    <ng-container *ngFor="let dot of [].constructor(viewStops); index as stop">
      <div class="stop stop--{{size}}-{{(stop + 1)}}"></div>
    </ng-container>
  </div>
</div>
